export default __webpack_public_path__ + "static/media/Desert.76a1e7e3.jpg";